import React from 'react'
import { Truck, Plus, Filter } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

export const Vendors: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Vendors Management</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">Manage supplier relationships and vendor information</p>
        </div>
        <Button><Plus className="w-4 h-4 mr-2" />Add Vendor</Button>
      </div>
      <Card>
        <CardContent className="pt-6">
          <div className="flex gap-4">
            <Input placeholder="Search vendors..." className="flex-1" />
            <Button variant="outline"><Filter className="w-4 h-4 mr-2" />Filter</Button>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Truck className="w-5 h-5" />Vendor Directory
          </CardTitle>
          <CardDescription>Supplier management and procurement tracking</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <Truck className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">Vendor Management</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">Comprehensive supplier relationship management</p>
            <Button variant="outline">Explore Features</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
